import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstPd8: [],
        pd8: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false
    },
    getters: {
        
    },
    mutations: {
        set(state, pd8){
            state.pd8 = pd8
            if (pd8)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
            state.pd8 = null
        },
        setParamsDataTable(state, payload){
            state.lstPd8 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
    },
    actions: {
        initForm(store){
            store.commit("initForm")
        },
        async find(store, pd8codigo ){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get(`/OryxPdv/IntegrationRepresentative/Find/${pd8codigo}`)
            .then(response => {
                let pd8 = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", pd8)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/OryxPdv/IntegrationRepresentative/Insert", store.state.pd8 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-integracao-guia")
                store.state.pd8 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/OryxPdv/IntegrationRepresentative/Update", store.state.pd8 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-integracao-guia")
                store.state.pd8 = null
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete(`/OryxPdv/IntegrationRepresentative/Delete/${store.state.pd8.pd8codigo}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/parametros-integracao-guia")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async search(store, { limit = 20, page = 1}){
            store.state.loading = true
            store.commit("initForm")
            let payload = await this._vm.$axios.get(`/OryxPdv/IntegrationRepresentative/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                store.commit("setParamsDataTable", payload)
                return true
            })
            .catch((error) => {
                store.state.lstPd0 = []
                store.state.search = ""
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.state.loading = false
            return payload
        },
    }
}